import { useState, useCallback } from "react";

const CUPCAKE_SVG = `<svg width="32" height="32" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 36h32l-4 24H20L16 36z" fill="#D4A76A"/>
  <path d="M12 32c0-6 4-12 8-14 2-4 6-6 12-6s10 2 12 6c4 2 8 8 8 14 0 2-1 4-4 4H16c-3 0-4-2-4-4z" fill="#F9A8D4"/>
  <circle cx="28" cy="26" r="2" fill="#FF6B6B"/>
  <circle cx="36" cy="24" r="2" fill="#4FC3F7"/>
  <circle cx="32" cy="28" r="2" fill="#FFD54F"/>
  <path d="M30 14c0-3 1-6 2-8" stroke="#D36135" stroke-width="2" stroke-linecap="round"/>
  <circle cx="32" cy="5" r="3" fill="#FF6B6B"/>
</svg>`;

export const CupcakeEasterEgg = () => {
  const [cupcakes, setCupcakes] = useState([]);
  const [active, setActive] = useState(false);

  const trigger = useCallback(() => {
    if (active) return;
    setActive(true);

    const newCupcakes = Array.from({ length: 30 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 2,
      duration: 2 + Math.random() * 2,
      size: 24 + Math.random() * 16,
      rotate: Math.random() * 360,
    }));

    setCupcakes(newCupcakes);
    setTimeout(() => {
      setCupcakes([]);
      setActive(false);
    }, 5000);
  }, [active]);

  return (
    <>
      <button
        onClick={trigger}
        className="fixed bottom-4 right-4 z-40 w-11 h-11 border border-[#323248] bg-[#10101A] hover:bg-[#FF3E8A] hover:border-[#FF3E8A] text-white flex items-center justify-center transition-colors duration-150 cursor-pointer opacity-70 hover:opacity-100"
        aria-label="Cupcake surprise"
        data-testid="cupcake-trigger"
        title="Click me!"
      >
        <svg width="20" height="20" viewBox="0 0 64 64" fill="none">
          <path d="M16 36h32l-4 24H20L16 36z" fill="#F9F8F6" />
          <path d="M12 32c0-6 4-12 8-14 2-4 6-6 12-6s10 2 12 6c4 2 8 8 8 14 0 2-1 4-4 4H16c-3 0-4-2-4-4z" fill="#F9F8F6" />
        </svg>
      </button>

      {cupcakes.length > 0 && (
        <div className="fixed inset-0 z-[9998] pointer-events-none overflow-hidden" data-testid="cupcake-rain">
          {cupcakes.map((c) => (
            <div
              key={c.id}
              className="absolute cupcake-fall"
              style={{
                left: `${c.left}%`,
                animationDelay: `${c.delay}s`,
                animationDuration: `${c.duration}s`,
                width: c.size,
                height: c.size,
                transform: `rotate(${c.rotate}deg)`,
              }}
              dangerouslySetInnerHTML={{ __html: CUPCAKE_SVG }}
            />
          ))}
        </div>
      )}
    </>
  );
};
